import React from "react";

import styles from './Footer.module.css';
import logo from "../../images/LogoAsl.svg";

export function Footer() {

    return (
        <footer className="login-page__footer">
            <span className="login-page__version">
                &copy; 2025 Tzion MyResult 2025.002.01.02
            </span>
        </footer>
    );
}